var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMaybeSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.76 8.39974C23.0824 5.69719 21.4549 2.5199 17.9901 2.40464C15.6802 2.3278 13.6927 3.52617 12.0277 5.99974C10.2462 3.60301 8.25872 2.40464 6.0653 2.40464C2.77517 2.40464 0.723461 5.4579 1.2954 8.39974C1.67669 10.361 5.25411 14.761 12.0277 21.5997C18.9676 14.6014 22.545 10.2014 22.76 8.39974Z",
    fill: "#EF3D3D",
    stroke: "white",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0135 23.2985C18.9524 23.2985 19.7135 22.5373 19.7135 21.5985C19.7135 20.6596 18.9524 19.8985 18.0135 19.8985C17.0746 19.8985 16.3135 20.6596 16.3135 21.5985C16.3135 22.5373 17.0746 23.2985 18.0135 23.2985Z",
    fill: "black",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4079 13.0549C14.5738 10.7733 15.7756 9.63257 18.0135 9.63257C20.7133 9.63257 21.6872 11.4126 21.6872 13.2534C21.6872 15.2426 19.972 15.9645 19.3824 16.2893C18.4698 16.7919 18.0135 17.7616 18.0135 19.1984",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4079 13.0549C14.5738 10.7733 15.7756 9.63257 18.0135 9.63257C20.7133 9.63257 21.6872 11.4126 21.6872 13.2534C21.6872 15.2426 19.972 15.9645 19.3824 16.2893C18.4698 16.7919 18.0135 17.7616 18.0135 19.1984",
    stroke: "black",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMaybeSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/maybe-selected.5d627bc1a9939fb1f1e51c250dd244a7.svg";